import React, { Fragment, useEffect, useRef, useState } from "react";

import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import {
  saveUpcScanAction,
  exportUpcScanExcelAction
} from "../../redux/actions/upcScanActions";
import { UPC_SCAN_SAVE_RESET } from "../../redux/constants/upcScanConstants";
import { clearErrors } from "../../redux/actions/userActions";
import Loader from "../loader/loader";
import api from "../../api";
import HoverFullText from "../products/HoverToolkit";
import ErrorAudio from "../images/error-audio.mp3";

const Dashboard = () => {

  const dispatch = useDispatch();

  const inputRef = useRef(null);
  const mappingInputRef = useRef(null);
  const inventoryInputRef = useRef(null);

  const [scanValue, setScanValue] = useState("");
  const [products, setProducts] = useState([]);
  const [wrongScans, setWrongScans] = useState([]);


  const [scannerType, setScannerType] = useState("single");
  // single | dual

  const [scanMode, setScanMode] = useState("mapping");
  // mapping | inventory

  const [mappingScanValue, setMappingScanValue] = useState("");
  const [inventoryScanValue, setInventoryScanValue] = useState("");

  const { loading, error, message } = useSelector(state => state.upcScan);

  const errorSoundRef = useRef(new Audio(ErrorAudio));

  useEffect(() => {
    const Headerlinkks = document.querySelectorAll(".headerLinks");
    const element = document.getElementById("dashboard");

    Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
    element?.classList.add("activeHeaderLink");

    document.title = `Dashboard - Admin Panel`;


  }, []);


  useEffect(() => {

    if (scannerType === "single") {

      setTimeout(() => {
        inputRef.current?.focus();
      }, 50);

    } else {

      setTimeout(() => {
        mappingInputRef.current?.focus();
      }, 50);

    }

  }, [scannerType]);

  const addWrongScan = (value) => {

    errorSoundRef.current.play();

    setWrongScans(prev => {

      const existing = prev.find(item => item.upc === value);

      if (existing) {

        const updatedItem = {
          ...existing,
          quantity: existing.quantity + 1
        };

        const filtered = prev.filter(item => item.upc !== value);

        return [updatedItem, ...filtered];
      }

      return [
        {
          upc: value,
          quantity: 1
        },
        ...prev
      ];
    });
  };
  const generateUpcCheckDigit = (code11) => {

    let sum = 0;

    for (let i = 0; i < 11; i++) {

      const digit = parseInt(code11[i], 10);

      sum += (i % 2 === 0)
        ? digit * 3
        : digit;
    }

    return (10 - (sum % 10)) % 10;
  };
  const normalizeBarcode = (barcode) => {

    let upc = barcode.trim().replace(/\s/g, "");

    if (!/^\d+$/.test(upc)) {
      return null;
    }

    if (![8, 10, 11, 12, 13, 14].includes(upc.length)) {
      return null;
    }

    // UPC-E -> UPC-A

    if (upc.length === 8) {

      const S = upc[0];
      const a = upc[1];
      const b = upc[2];
      const c = upc[3];
      const d = upc[4];
      const e = upc[5];
      const N = upc[6];

      let expanded;

      if (["0", "1", "2"].includes(N)) {
        expanded = `${S}${a}${b}${N}0000${c}${d}${e}`;
      }
      else if (N === "3") {
        expanded = `${S}${a}${b}${c}00000${d}${e}`;
      }
      else if (N === "4") {
        expanded = `${S}${a}${b}${c}${d}00000${e}`;
      }
      else {
        expanded = `${S}${a}${b}${c}${d}${e}0000${N}`;
      }

      const checkDigit = generateUpcCheckDigit(expanded);

      upc = expanded + checkDigit;
    }

    // 10 -> 12

    if (upc.length === 10) {

      upc = "0" + upc;

      const checkDigit = generateUpcCheckDigit(upc);

      upc += checkDigit;
    }

    // 11 -> 12

    else if (upc.length === 11) {

      const checkDigit = generateUpcCheckDigit(upc);

      upc += checkDigit;
    }

    if (![12, 13, 14].includes(upc.length)) {
      return null;
    }

    return upc;
  };

  const addProductEntry = (
    finalUpc,
    quantityToAdd,
    description,
    sourceMode
  ) => {

    setProducts(prev => {

      const existing = prev.find(
        item => item.upc === finalUpc
      );

      if (existing) {

        const updated = {
          ...existing,
          quantity: existing.quantity + quantityToAdd
        };

        const filtered = prev.filter(
          item => item.upc !== finalUpc
        );

        return [updated, ...filtered];
      }

      return [
        {
          upc: finalUpc,
          quantity: quantityToAdd,
          description,
          sourceMode
        },
        ...prev
      ];
    });
  };

  const processMappingScan = async (normalizedUpc) => {

    let finalUpc = normalizedUpc;
    let quantityToAdd = 1;

    try {

      const { data: mappingData } = await api.get(
        `/api/v1/mapping/get-by-parent-barcode?parent_barcode=${normalizedUpc}`
      );

      

      if (
        mappingData.success &&
        mappingData.mapping
      ) {

        finalUpc = mappingData.mapping.child_barcode;

        quantityToAdd =
          Number(mappingData.mapping.unit_case) || 1;
      }

    } catch (error) {
      // ignore
    }

    let description = "Not added";

    try {

      const { data } = await api.get(
        `/api/v1/product-description?scan_code=${finalUpc}`
      );

      if (data.success) {

        description =
          data.description || "Not added";
      }

    } catch (error) {
      description = "Not added";
    }

    addProductEntry(
      finalUpc,
      quantityToAdd,
      description,
      "mapping"
    );
  };

  const processInventoryScan = async (normalizedUpc) => {

    let finalUpc = normalizedUpc;

    let description = "Not added";

    let quantityToAdd = 1;

    try {

      const { data } = await api.get(
        `/api/v1/product-description?scan_code=${finalUpc}`
      );
      

      if (data.success) {

        description =
          data.description || "Not added";

        const unitCase =
          Number(data.unit_case);

        if (
          !isNaN(unitCase) &&
          unitCase > 0
        ) {

          quantityToAdd = unitCase;
        }
      }

    } catch (error) {
      description = "Not added";
    }

    addProductEntry(
      finalUpc,
      quantityToAdd,
      description,
      "inventory"
    );
  };
  // Handle scanner Enter


  const handleKeyDown = async (e) => {

    if (e.key !== "Enter") return;

    if (!scanValue.trim()) return;

    const originalValue = scanValue.trim();

    const normalizedUpc =
      normalizeBarcode(originalValue);

    if (!normalizedUpc) {

      addWrongScan(originalValue);

      setScanValue("");

      return;
    }

    try {

      if (scanMode === "mapping") {

        await processMappingScan(
          normalizedUpc
        );

      } else {

        await processInventoryScan(
          normalizedUpc
        );
      }

    } catch (error) {

      addWrongScan(originalValue);
    }

    setScanValue("");
  };

  const handleMappingScanner = async (e) => {

    if (e.key !== "Enter") return;

    if (!mappingScanValue.trim()) return;

    const originalValue =
      mappingScanValue.trim();

    const normalizedUpc =
      normalizeBarcode(originalValue);

    if (!normalizedUpc) {

      addWrongScan(originalValue);

      setMappingScanValue("");

      return;
    }

    try {

      await processMappingScan(
        normalizedUpc
      );

    } catch (error) {

      addWrongScan(originalValue);
    }

    setMappingScanValue("");
  };

  const handleInventoryScanner = async (e) => {

    if (e.key !== "Enter") return;

    if (!inventoryScanValue.trim()) return;

    const originalValue =
      inventoryScanValue.trim();

    const normalizedUpc =
      normalizeBarcode(originalValue);

    if (!normalizedUpc) {

      addWrongScan(originalValue);

      setInventoryScanValue("");

      return;
    }

    try {

      await processInventoryScan(
        normalizedUpc
      );

    } catch (error) {

      addWrongScan(originalValue);
    }

    setInventoryScanValue("");
  };

  // Remove valid product
  const handleRemove = (upc) => {

    setProducts(prev =>
      prev
        .map(p =>
          p.upc === upc
            ? { ...p, quantity: p.quantity - 1 }
            : p
        )
        .filter(p => p.quantity > 0)
    );
  };

  // Remove wrong scan
  const handleWrongRemove = (upc) => {

    setWrongScans(prev =>
      prev
        .map(p =>
          p.upc === upc
            ? { ...p, quantity: p.quantity - 1 }
            : p
        )
        .filter(p => p.quantity > 0)
    );
  };

  const handleSave = () => {

    if (products.length === 0 && wrongScans.length === 0) return;

    console.log(products, wrongScans);

    dispatch(saveUpcScanAction({
      products,
      wrongScans
    }));

    setProducts([]);
    setWrongScans([]);
    setScannerType("single");
    setScanMode("mapping");
    setScanValue("");
    setMappingScanValue("");
    setInventoryScanValue("");
  };

  const handleExport = () => {

    if (products.length === 0 && wrongScans.length === 0) return;

    dispatch(exportUpcScanExcelAction({
      products,
      wrongScans
    }));

    setProducts([]);
    setWrongScans([]);
    setScannerType("single");
    setScanMode("mapping");
    setScanValue("");
    setMappingScanValue("");
    setInventoryScanValue("");
  };

  useEffect(() => {

    if (message) {

      toast.success(message);

      dispatch({ type: UPC_SCAN_SAVE_RESET });

      setProducts([]);
      setWrongScans([]);
    }

    if (error) {

      toast.error(error);

      dispatch(clearErrors());
    }

  }, [error, message, dispatch]);

  return (
    <Fragment>

      {loading && <Loader />}

      <section className="bg-white rounded-[1vmax] shadow-1 p-[2vmax] ml-[1.5vmax] mr-[2.5vmax] ">


  <div className="mb-8">

          <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-3xl p-6 ">

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

              {/* Scanner Type */}
              <div>

                <h3 className="text-[18px] font-bold text-slate-800 mb-3">
                  Scanner Layout
                </h3>

                <div className="flex gap-3">

                  <button
                    type="button"
                    onClick={() => setScannerType("single")}
                    className={`px-5 py-2.5 rounded-2xl font-medium transition-all duration-200
            ${scannerType === "single"
                        ? "bg-blue-600 text-white shadow-lg shadow-blue-200 scale-105"
                        : "bg-white text-slate-600 border border-slate-300 hover:bg-slate-50"
                      }`}
                  >
                    Single Scanner Mode
                  </button>

                  <button
                    type="button"
                    onClick={() => setScannerType("dual")}
                    className={`px-5 py-2.5 rounded-2xl font-medium transition-all duration-200
            ${scannerType === "dual"
                        ? "bg-blue-600 text-white shadow-lg shadow-blue-200 scale-105"
                        : "bg-white text-slate-600 border border-slate-300 hover:bg-slate-50"
                      }`}
                  >
                    Dual Scanner Mode
                  </button>

                </div>

              </div>

              {/* Processing Mode */}
              {scannerType === "single" && (

                <div>

                  <h3 className="text-[18px] font-bold text-slate-800 mb-3">
                    Processing Mode
                  </h3>

                  <div className="flex gap-3">

                    <button
                      type="button"
                      onClick={() => setScanMode("mapping")}
                      className={`px-5 py-2.5 rounded-2xl font-medium transition-all duration-200
              ${scanMode === "mapping"
                          ? "bg-emerald-600 text-white shadow-lg shadow-emerald-200 scale-105"
                          : "bg-white text-slate-600 border border-slate-300 hover:bg-slate-50"
                        }`}
                    >
                      Mapping Mode
                    </button>

                    <button
                      type="button"
                      onClick={() => setScanMode("inventory")}
                      className={`px-5 py-2.5 rounded-2xl font-medium transition-all duration-200
              ${scanMode === "inventory"
                          ? "bg-purple-600 text-white shadow-lg shadow-purple-200 scale-105"
                          : "bg-white text-slate-600 border border-slate-300 hover:bg-slate-50"
                        }`}
                    >
                      Inventory Mode
                    </button>

                  </div>

                </div>

              )}

            </div>

          </div>

        </div>
         <div className="mb-8">

          {/* Single Scanner */}

          {scannerType === "single" && (

            <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-3xl p-6">

              <div className="flex items-center justify-between mb-3">

                <label className="text-[15px] font-semibold text-slate-700">
                  Scan Product UPC
                </label>

                <span
                  className={`text-xs px-3 py-1 rounded-full font-semibold
          ${scanMode === "mapping"
                      ? "bg-emerald-100 text-emerald-700"
                      : "bg-purple-100 text-purple-700"
                    }`}
                >
                  {scanMode === "mapping"
                    ? "Mapping Mode"
                    : "Inventory Mode"}
                </span>

              </div>

              <input
                ref={inputRef}
                type="text"
                value={scanValue}
                onChange={(e) => setScanValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Scan barcode here..."
                className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-5 py-4 text-[16px] focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all"
              />

            </div>

          )}

          {/* Dual Scanner */}

          {scannerType === "dual" && (

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">

              <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-3xl p-6">

                <div className="flex items-center justify-between mb-3">

                  <label className="text-[15px] font-semibold text-slate-700">
                    Mapping Scanner
                  </label>

                  <span className="text-xs px-3 py-1 rounded-full font-semibold bg-emerald-100 text-emerald-700">
                    Mapping Mode
                  </span>

                </div>

                <input
                  ref={mappingInputRef}
                  type="text"
                  onKeyDown={handleMappingScanner}
                  value={mappingScanValue}
                  onChange={(e) => setMappingScanValue(e.target.value)}
                  placeholder="Scan mapping barcode..."
                  className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-5 py-4 text-[16px] focus:outline-none focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all"
                />

              </div>

              <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-3xl p-6">

                <div className="flex items-center justify-between mb-3">

                  <label className="text-[15px] font-semibold text-slate-700">
                    Inventory Scanner
                  </label>

                  <span className="text-xs px-3 py-1 rounded-full font-semibold bg-purple-100 text-purple-700">
                    Inventory Mode
                  </span>

                </div>

                <input
                  ref={inventoryInputRef}
                  type="text"
                  value={inventoryScanValue}
                  onKeyDown={handleInventoryScanner}
                  onChange={(e) => setInventoryScanValue(e.target.value)}
                  placeholder="Scan inventory barcode..."
                  className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-5 py-4 text-[16px] focus:outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-500 transition-all"
                />

              </div>

            </div>

          )}

        </div>


        {/* ========================================= */}
        {/* Scanner Inputs */}
        {/* ========================================= */}

       
        {/* Valid Products Table */}
        <div className="overflow-x-auto">

          <table className="w-full border-collapse">

            <thead>
              <tr className="bg-gray-100 text-left text-[14px] text-gray-600">
                <th className="p-3 rounded-l-xl">No.</th>
                <th className="p-3">UPC</th>
                <th className="p-3">Quantity</th>
                <th className="p-3">Description</th>
                <th className="p-3 rounded-r-xl">Action</th>
              </tr>
            </thead>

            <tbody>

              {products.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center p-6 text-gray-400">
                    No products scanned yet
                  </td>
                </tr>
              )}

              {products.map((item, index) => (

                <tr
                  key={item.upc}
                  className="border-b last:border-b-0 hover:bg-gray-50"
                >

                  <td className="p-3">{products.length - index}</td>

                  <td className="p-3 font-mono">
                    {item.upc}
                  </td>

                  <td className="p-3 font-semibold">
                    {item.quantity}
                  </td>

                  <td className={`p-3 ${item.description === "Not added" && "text-red-500 italic"}`}>
                    {
                      item.description === "Not added"
                        ? "Not added"
                        : <HoverFullText text={item.description} sliceLength={30} />
                    }
                  </td>

                  <td className="p-3">

                    <button
                      onClick={() => handleRemove(item.upc)}
                      className="text-red-500 hover:text-red-700 text-[18px]"
                      title="Remove one"
                    >
                      ✕
                    </button>

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

        {/* Wrong Scans Table */}
        <div className="overflow-x-auto mt-10">

          <h2 className="text-[18px] font-semibold text-red-500 mb-4">
            Invalid Scans
          </h2>

          <table className="w-full border-collapse">

            <thead>
              <tr className="bg-red-100 text-left text-[14px] text-red-700">
                <th className="p-3 rounded-l-xl">No.</th>
                <th className="p-3">UPC</th>
                <th className="p-3">Quantity</th>
                <th className="p-3 rounded-r-xl">Action</th>
              </tr>
            </thead>

            <tbody>

              {wrongScans.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center p-6 text-gray-400">
                    No Invalid scans
                  </td>
                </tr>
              )}

              {wrongScans.map((item, index) => (

                <tr
                  key={item.upc}
                  className="border-b last:border-b-0 hover:bg-red-50"
                >

                  <td className="p-3">
                    {wrongScans.length - index}
                  </td>

                  <td className="p-3 font-mono text-red-500">
                    {item.upc}
                  </td>

                  <td className="p-3 font-semibold">
                    {item.quantity}
                  </td>

                  <td className="p-3">

                    <button
                      onClick={() => handleWrongRemove(item.upc)}
                      className="text-red-500 hover:text-red-700 text-[18px]"
                      title="Remove one"
                    >
                      ✕
                    </button>

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

        {/* Buttons */}
        <div className="flex justify-end items-center gap-4 mt-4">

          <button
            className={`${products.length === 0 && wrongScans.length === 0 && "opacity-50 cursor-not-allowed"} bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg`}
            onClick={() => {
              setProducts([]);
              setWrongScans([])
              setScannerType("single");
              setScanMode("mapping");
              setScanValue("");
              setMappingScanValue("");
              setInventoryScanValue("");
            }}
            disabled={products.length === 0 && wrongScans.length === 0}
          >
            Cancel
          </button>

          <button
            className={`bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg ${(products.length === 0 && wrongScans.length === 0) && "opacity-50 cursor-not-allowed"}`}
            onClick={() => handleSave()}
            disabled={products.length === 0 && wrongScans.length === 0}
          >
            Save
          </button>

          <button
            className={`bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg ${(products.length === 0 && wrongScans.length === 0) && "opacity-50 cursor-not-allowed"}`}
            onClick={handleExport}
            disabled={products.length === 0 && wrongScans.length === 0}
          >
            Export Excel
          </button>

        </div>

      </section>


      <br />
      <br />
      <br />
      <br />
      <br />

    </Fragment>
  );
};

export default Dashboard;